export default __webpack_public_path__ + "static/media/medium_priority_banner.aff3f914.svg";